export function cleanDataFromOmittedInPlace(data) {
    let i = 0

    while (i < data.length) {
        const entry = data[i]

        if (shouldOmitFromLog(entry)) {
            data.splice(i, 1)
            continue
        }
        i++
    }

    return data
}

function shouldOmitFromLog(entry) {
    return Boolean(entry?.payload?.omitFromLog)
}
